import { GetContactsByStartDatePatternQuery } from '@zaplify/graphql';
import React from 'react';
import { ContactAvatar } from '../../../components/contact-avatar';
import { ProspectDataExperienceDto } from '@zaplify/prospects';
import dayjs from 'dayjs';
import { formatDistanceToNow } from 'date-fns';
import { cn } from '@shadcn/ui';

// interface Contact {
//     id: string;
//     name: string;
//     profileImage: string;
//     newTitle: string;
//     newCompany: string;
//     type: 'promotion' | 'new-company';
//     startDate: string;
// }

interface ContactCardProps {
    contact: GetContactsByStartDatePatternQuery['Contacts'][number];
    jobStartDate: string;
    jobChangeType: 'promotion' | 'new-company';
    onClick?: () => void;
    index: number;
}

const getTypeText = (type: 'promotion' | 'new-company'): string => {
    switch (type) {
        case 'promotion':
            return '🎉 Promotion';
        case 'new-company':
            return '🚀 New Company';
    }
};

export const ContactCard: React.FC<ContactCardProps> = ({ contact, index, jobChangeType, jobStartDate, onClick }) => {
    return (
        <div
            className={cn(
                'group bg-white/80 backdrop-blur-sm rounded-2xl p-3 transition-all duration-300 animate-fade-in border border-gray-200',
                onClick && 'cursor-pointer hover:bg-white hover:scale-105 hover:shadow-lg'
            )}
            style={{ animationDelay: `${index * 100}ms` }}
            onClick={onClick}
        >
            <div className="text-center">
                {/* Profile Image */}
                <div className="relative mx-auto mb-2 w-12 h-12">
                    <ContactAvatar avatarUrl={contact.linkedinProfileImgUrl} fullName={contact.fullName} size="lg" />
                    <div className="absolute -top-1 -right-1 w-5 h-5 bg-green-400 rounded-full border-2 border-white flex items-center justify-center">
                        <span className="text-white text-xs">🎉</span>
                    </div>
                </div>

                {/* Name */}
                <h3 className="font-semibold text-gray-700 mb-1 text-xs leading-tight">{contact.fullName}</h3>

                {/* New Title & Company */}
                <div className="text-xs text-gray-600 mb-2 line-clamp-2">
                    <div className="font-medium">{contact.occupationTitle}</div>
                    <div className="text-gray-500">{contact.organizationName}</div>
                </div>

                {/* Timeline */}
                <div className="text-xs bg-gray-100 rounded-full px-2 py-1 text-gray-600 border border-gray-200">
                    {formatDistanceToNow(new Date(jobStartDate))}
                </div>

                {/* Promotion indicator */}
                <div
                    className={cn(
                        'mt-2 text-xs font-medium',
                        jobChangeType === 'promotion' ? 'text-text-success-primary' : 'text-text-brand-primary'
                    )}
                >
                    {getTypeText(jobChangeType)}
                </div>
            </div>
        </div>
    );
};
